import AddProductToCartModalManager from './AddProductToCartModalManager.vue';
import GoToCheckoutModal from './GoToCheckoutModal.vue';

export default {
    AddProductToCartModalManager,
    GoToCheckoutModal,
};
